import React, { Component } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { Route, Switch } from "react-router-dom";
import DashboardPage from "../pages/DashboardPage";
import { AuthenticatedRoute } from "./common/AuthenticatedRoute";
import LoginPage from "../pages/auth/LoginPage";
import NotAuthorizedPage from "../pages/common/NotAuthorizedPage";
import Page404 from "../pages/common/Page404";
// import NavBar from "./common/NavBar";
import DatacenterListPage from "../pages/DatacentersListPage";
import DataCenterPage from "../pages/DataCenterPage";
import UpsMain from "./infrastructure/ups/UpsMain";
import TransformerMain from "./infrastructure/transformer/TransformerMain";
import HtPanelMain from "./infrastructure/ht-panel/HtPanelMain";
import SmpsMain from "./infrastructure/smps/SmpsMain";
import PacMain from "./infrastructure/pac/PacMain";
import DgSetMain from "./infrastructure/dg-set/DgSetMain";
import AirCooledChillerMain from "./infrastructure/air-cooled-chiller/AirCooledChillerMain";
import IdcTemperatureMain from "./infrastructure/idc-temperature/IdcTemperatureMain";
import CustomerMain from "./customers/CustomerMain";
import CustomerDetails from "./customers/CustomerDetails";
import AccessLogsMain from "./customers/access-logs/AccessLogsMain";
// import TemperatureHumidityMain from "./customers/temperature-humidity/TemperatureHumidityMain";
import PowerUtilizatioMain from "./customers/power-utilization/PowerUtilizationMain";
import AdminMain from "./admins/AdminMain";
import AuditLogsMain from "./audit-logs/AuditLogsMain";
import SystemConfigMain from "./system-config/SystemConfigMain";
import CCTVImageMain from "./customers/cctv-image/CCTVImageMain";
import UpTimeMain from "./customers/up-time/UpTimeMain";
import TicketMain from "./customers/tickets/TicketMain";
import SlaMatrixMain from "./sla-matrix/SlaMatrixMain";
// import SlaMatrix from "./customers/sla-matrix/SlaMatrix";
// import TempAndRhMain from "./infrastructure-automation/temp-rh/TempAndRhMain";
// import PowerUtilizationMain from "./customers/power-utilization/PowerUtilizationMain";
import PowerUtilizatioReadingMain from "./infrastructure-automation/power-utilization/PowerUtilizationWrapperMain";
import AuthorizationContacts from "./customers/authorization-contacts/AuthorizationContacts";
import ServiceDetails from "./customers/service-details/ServiceDetails";
import PreviousMeeting from "./customers/previous-meetings/PreviousMeeting";
import ActivityUpdates from "./customers/activity-updates/ActivityUpdates";
import CustomerRackStatus from "./customers/customer-rack-status/CustomerRackStatus";
import AssignEscalationMatrix from "./customers/assign-escalation-matrix/AssignEscalationMatrix";
import PMSchedule from "./customers/preventive-maintenence-schedule/PMSchedule";
import MiscellaneousFile from "./customers/miscellaneous-files/MiscellaneousFiles";
// 🚫 CHANGE PASSWORD — self-service password change is disabled; see
// docs/SSO-LOGIN-POLICY.md. Microsoft SSO is the promoted sign-in path and
// passwords now exist only as the emergency fallback.
// import ChangePasswordPage from "./change-password/ChangePasswordPage";
import { isTokenExpired } from "../services/UtilService";
import MomStatusDetails from "./dashboard/MomStatusDetails";
import SlaMatrixAlertDetails from "./dashboard/SlaMatrixAlertDetails";
import TemperatureHumidityWrapper from "./customers/temperature-humidity/TemperatureHumidityWrapper";
import SlaMatrixTabMain from "./customers/sla-matrix/SlaMatrixTabMain";
import TempAndRhTabMain from "./infrastructure-automation/temp-rh/TempAndRhTabMain";
import MergedCustomers from "./customers/merged-customers/MergedCustomers";
import ViewMergedCustomer from "./customers/merged-customers/ViewMergedCustomer";
import CustomerMeetingMain from "./customer-meetings/CustomerMeetingMain";
export interface RoutesMainProps extends RouteComponentProps { }

export interface RoutesMainState { }

class RoutesMain extends Component<RoutesMainProps, RoutesMainState> {
  render() {
    return (
      <React.Fragment>
        <main
          className={!isTokenExpired() ? "main-container" : "login-container"}
        >
          <Switch>
            <Route path="/login" exact component={LoginPage} />
            <AuthenticatedRoute path="/" exact component={DashboardPage} />
            <AuthenticatedRoute
              path="/datacenters"
              exact
              component={DatacenterListPage}
            />
            <AuthenticatedRoute
              path="/datacenters/:dataCenterId/infrastructure/transformer"
              exact
              component={TransformerMain}
            />
            <AuthenticatedRoute
              path="/datacenters/:dataCenterId"
              exact
              component={DataCenterPage}
            />
            <AuthenticatedRoute
              path="/datacenters/:dataCenterId/infrastructure/ups"
              exact
              component={UpsMain}
            />
            <AuthenticatedRoute
              path="/datacenters/:dataCenterId/infrastructure/ht-panel"
              exact
              component={HtPanelMain}
            />
            <AuthenticatedRoute
              path="/datacenters/:dataCenterId/infrastructure/smps"
              exact
              component={SmpsMain}
            />
            <AuthenticatedRoute
              path="/datacenters/:dataCenterId/infrastructure/pac"
              exact
              component={PacMain}
            />
            <AuthenticatedRoute
              path="/datacenters/:dataCenterId/infrastructure/dg-set"
              exact
              component={DgSetMain}
            />
            <AuthenticatedRoute
              path="/datacenters/:dataCenterId/infrastructure/cooled-chiller"
              exact
              component={AirCooledChillerMain}
            />
            <AuthenticatedRoute
              path="/datacenters/:dataCenterId/infrastructure/idc-temperature"
              exact
              component={IdcTemperatureMain}
            />
            <AuthenticatedRoute
              path="/datacenters/:dataCenterId/infrastructure-automation/temp-rh"
              exact
              component={TempAndRhTabMain}
            />
            <AuthenticatedRoute
              path="/datacenters/:dataCenterId/infrastructure-automation/power-utilization"
              exact
              component={PowerUtilizatioReadingMain}
            />
            <AuthenticatedRoute
              path="/customers"
              exact
              component={CustomerMain}
            />
            <AuthenticatedRoute
              path="/customers/merged"
              exact
              component={MergedCustomers}
            />
            <AuthenticatedRoute
              path="/customers/merged/:mergedCustomerId"
              exact
              component={ViewMergedCustomer}
            />
            <AuthenticatedRoute
              path="/customers/:customerId"
              exact
              component={CustomerDetails}
            />
            <AuthenticatedRoute
              path="/customers/:customerId/access-logs"
              exact
              component={AccessLogsMain}
            />
            <AuthenticatedRoute
              path="/customers/:customerId/temperature-humidity"
              exact
              component={TemperatureHumidityWrapper}
            />
            <AuthenticatedRoute
              path="/customers/:customerId/power-utilization"
              exact
              component={PowerUtilizatioMain}
            />
            <AuthenticatedRoute
              path="/customers/:customerId/cctv-image"
              exact
              component={CCTVImageMain}
            />
            <AuthenticatedRoute
              path="/customers/:customerId/up-time"
              exact
              component={UpTimeMain}
            />
            <AuthenticatedRoute
              path="/customers/:customerId/access-permission-and-material-movement"
              // path="/customers/:customerId/service-tickets"
              exact
              component={TicketMain}
            />
            <AuthenticatedRoute
              path="/customers/:customerId/complaints-and-other-requests"
              // path="/customers/:customerId/incidents"
              exact
              component={TicketMain}
            />
            <AuthenticatedRoute
              path="/customers/:customerId/remote-hand-services"
              exact
              component={TicketMain}
            />
            <AuthenticatedRoute
              path="/customers/:customerId/sla-matrixes-config"
              exact
              component={SlaMatrixTabMain}
            // component={SlaMatrix}
            />
            <AuthenticatedRoute
              path="/customers/:customerId/authorized-contacts"
              exact
              component={AuthorizationContacts}
            />
            <AuthenticatedRoute
              path="/customers/:customerId/service-details"
              exact
              component={ServiceDetails}
            />
            <AuthenticatedRoute
              path="/customers/:customerId/customer-meetings"
              // path="/customers/:customerId/previous-meetings"
              exact
              component={PreviousMeeting}
            />
            <AuthenticatedRoute
              path="/customers/:customerId/activity-updates"
              exact
              component={ActivityUpdates}
            />
            <AuthenticatedRoute
              path="/customers/:customerId/customer-rack-status"
              exact
              component={CustomerRackStatus}
            />
            <AuthenticatedRoute
              path="/customers/:customerId/assign-escalation-matrix"
              exact
              component={AssignEscalationMatrix}
            />
            <AuthenticatedRoute
              path="/customers/:customerId/preventive-maintenence-schedule"
              exact
              component={PMSchedule}
            />
            <AuthenticatedRoute
              path="/customers/:customerId/others-files"
              exact
              component={MiscellaneousFile}
            />
            <AuthenticatedRoute path="/admins" exact component={AdminMain} />
            <AuthenticatedRoute path="/audit-logs" exact component={AuditLogsMain} />
            <AuthenticatedRoute
              path="/system-configs"
              exact
              component={SystemConfigMain}
            />
            <AuthenticatedRoute
              path="/sla-matrixes"
              exact
              component={SlaMatrixMain}
            />
            <AuthenticatedRoute
              path="/customer-meetings"
              exact
              component={CustomerMeetingMain}
            />
            <AuthenticatedRoute
              path="/mom-status-count"
              exact
              component={MomStatusDetails}
            />
            <AuthenticatedRoute
              path="/sla-matrix-alert-details"
              exact
              component={SlaMatrixAlertDetails}
            />
            {/* 🚫 CHANGE PASSWORD — with no route registered, /change-password
                falls through to the Page404 catch-all below.
            <AuthenticatedRoute
              path="/change-password"
              exact
              component={ChangePasswordPage}
            />
            */}
            <Route path="/not-authorized" exact component={NotAuthorizedPage} />
            <Route path="" exact component={Page404} />
          </Switch>
        </main>
      </React.Fragment>
    );
  }
}

export default withRouter(RoutesMain);
